import { ROUTE_DOCS_MONITORING } from '@/common/constants';
import { Pagination } from '@/components/pagination/Pagination';
import { ScrollArea } from '@/components/ui/scroll-area';
import { IFarmer } from '@/features/monitoring/models/IMonitoring';
import { cn } from '@/lib/utils';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useParams } from 'react-router-dom';

interface SidebarProps {
  className?: string;
  items?: IFarmer[];
  isLoading?: boolean;
  totalPages: number;
  totalElements: number;
}

export const SidebarFarmers: FC<SidebarProps> = ({
  items = [],
  isLoading,
  totalPages,
  totalElements,
}) => {
  const { t } = useTranslation();
  const { lang, type, region_id, district_id, id } = useParams();
  const safeItems = Array.isArray(items) ? items : [];

  return (
    <div
      className={`flex flex-col w-[440px] min-w-[440px] bg-white  h-[calc(100vh-57px)]  overflow-hidden border-r`}
    >
      <ScrollArea className={cn('flex-1')}>
        <div className="relative">
          {safeItems.length === 0 && !isLoading ? (
            <div className="text-center text-black text-xl py-4">
              {t('no.data')}
            </div>
          ) : (
            safeItems.map((item, i) => (
              <NavLink
                to={{
                  pathname: `/${lang}/${ROUTE_DOCS_MONITORING}/${type || 'COTTON'}/${region_id}/${district_id}/farmers/${item?.id}`,
                  search: window.location.search,
                }}
                replace
                key={i}
                className={cn(
                  'py-3 px-6 border-b bg-white cursor-pointer  transition-all grid grid-cols-12 gap-[10px] relative  duration-300',
                  id === String(item?.id) && 'bg-green-default/10',
                )}
              >
                <span
                  className={cn(
                    id === String(item?.id)
                      ? 'bg-green-default  opacity-100'
                      : 'opacity-0',
                    'duration-300 absolute left-0 inset-y-0 h-full w-1.5',
                  )}
                />
                <div className="flex flex-col items-start col-span-5">
                  <p className="text-[11px] font-medium text-gray-graphite">
                    {t('lands')}
                  </p>
                  <p className="text-sm text-midnight-default">
                    {item?.name_uz}
                  </p>
                </div>
                <div className="flex flex-col items-start col-span-6">
                  <p className="text-[11px] font-medium text-gray-graphite">
                    {t('lot.number')}
                  </p>
                  <p className="text-sm text-dark-blue w-[200px] font-semibold line-clamp-1">
                    {item?.regnum}
                  </p>
                </div>

                <div className="flex flex-col items-start col-span-5">
                  <p className="text-[11px] font-medium text-gray-graphite">
                    {t('farmer')}
                  </p>
                  <p className="text-sm w-32 text-midnight-default truncate">
                    {item?.farmer_name}
                  </p>
                </div>

                <div className="flex flex-col items-start col-span-4">
                  <p className="text-[11px] font-medium text-gray-graphite">
                    {t('area')}
                  </p>
                  <p className="text-sm text-midnight-default">
                    {item?.area} ga
                  </p>
                </div>
                <div className="flex flex-col items-start col-span-3">
                  <p className="text-[11px] font-medium text-gray-graphite">
                    {t('farmer.stir')}
                  </p>
                  <p className="text-sm text-midnight-default">
                    {item?.tax_number}
                  </p>
                </div>
              </NavLink>
            ))
          )}
        </div>
      </ScrollArea>
      <div className="bg-gray-100 h-[70px] border-t flex items-center px-4">
        {totalElements > 0 && (
          <Pagination totalPages={totalPages} totalElements={totalElements} />
        )}
      </div>
    </div>
  );
};
